import AbstractHybrisApi from '@/api/AbstractHybrisApi';

export default class ConfigurationApi extends AbstractHybrisApi {
  async global() {
    return this.request({
      method: 'get',
      version: 'v2',
      url: '/configuration/global',
    });
  }

  async features() {
    return this.request({
      method: 'get',
      version: 'v2',
      url: '/configuration/featuretoggles',
    });
  }

  async translations(lang?: string) {
    return this.request({
      method: 'get',
      version: 'v2',
      url: '/configuration/i18n',
      params: {
        lang,
      },
    });
  }
}
